import template from './offices.html';
import controller from './offices.controller';
import './offices.scss';

let officesComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default officesComponent;



// WEBPACK FOOTER //
// ./client/app/components/offices/offices.component.js